<template>
  <el-table 
  ref="table"
  :data="data" 
  border 
  v-loading="loading"
  height="100%" 
  show-overflow-tooltip  
  highlight-current-row 
  :cell-style="{ padding: '5px' }" 
  :header-cell-style="{height: '40px',padding: '5px'}"
  @current-change="handleCurrentChange" 
  @row- ='handleDblClick'>
    <template v-for="column in columns_">
      <el-table-column 
        v-if="!column.hide"
        
        :key="column.prop" 
        :prop="column.prop"
        :label="translate?column.label:column.prop"
        :align="column.align || 'left'" 
        :width="column.width || 100"
        :min-width="column.min_width" 
        :fixed="column.fixed" 
        show-overflow-tooltip
      >
       <template #default="scope">
        <div>{{ getFieldValueMapping(column.prop,scope.row.properties) }}</div>
       </template>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
export default {
  name: 'AttributeTable',
  props:{
    data:{
      type:Array,
      default:()=>[]
    },
    translate:{
      type:Boolean,
      default:()=>true
    },
    loading:{
      type:Boolean,
      default:()=>true
    }
  },
  data() {
    return {
      columns_:[],
      fieldValueMapping:{},
    };
  },
  mounted() {
 
  },

  methods: {
    handleCurrentChange(row,oldRow){
      this.$emit('current-change',row, oldRow)
    },
    handleDblClick(row, column, event){
      this.$emit('row-dblclick',row, column,event)
    },
    init(props){
      const fields = props.fields || [] 
      //字段中文翻译，不区分大小写，默认映射中字段名大写
      this.fieldValueMapping =  props.fieldValueMapping || {}
      this.columns_ = this.initColumns(fields)
    },
    initColumns(fields){
      const columns = []
      fields.forEach(field => {
        columns.push({
          prop:field.name,
          label:field.alias || field.name,
        })
      });
      return columns
    },
    getFieldMapping(name){
      return this.fieldMapping? this.fieldMapping[name] || name : name
    },
    getFieldValueMapping(name,properties){
      const value = properties?properties[name] : null
      if (!name) {
        return value || ''
      }
      const valueMapping = this.fieldValueMapping[name.toUpperCase()] || {}
      return valueMapping[value]? valueMapping[value] : value
    },
  },
};
</script>

<style scoped>
::v-deep .current-row > td {
   background: rgba(0, 158, 250, 0.219) !important;
}
::v-deep .el-table__body-wrapper {
  height: calc(100% - 40px)!important;   
}
</style>